export const useStyles = theme => ({
  helperText: {
    color: 'red',
    marginBottom: '20px',
  },
  mightyDisc: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.8vw',
      marginLeft: '-16px',
    },
  }
});
